import { ModuleWithProviders, NgModule } from '@angular/core';
import { XeroIntegrationService } from './xero-integration.service';
import { XeroDataResolve } from './xero-data.resolve';
import { XeroDataEffects } from './xero-data.effects';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { FEATURE_NAME, reducer } from './xero-data.reducer';
import { StoreModule } from '@ngrx/store';
import { XeroDataStore } from './xero-data.store';
import { XeroDataDispatcher } from './xero-data.dispatcher';
import { XeroGuard } from './guards/xero-guard';
import { XeroPermissionGuard } from './guards/xero-permission.guard';

export const xeroDataEffects = [XeroDataEffects];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(FEATURE_NAME, reducer),
  ],
})
export class XeroDataModule {
  static forRoot(): ModuleWithProviders<XeroDataModule> {
    return {
      ngModule: XeroDataModule,
      providers: [
        XeroDataStore,
        XeroDataDispatcher,
        XeroIntegrationService,
        XeroDataResolve,
        XeroGuard,
        XeroPermissionGuard,
      ],
    };
  }
}
